/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { InfinitySpin } from "react-loader-spinner";
import { Button, Card, TextField } from "@mui/material";

class AppUser extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      DataisLoaded: false,
      card_num: "",
      type: "",
      start_date: "",
      end_date: "",
      currentPage: 1,
      totalPages: 1,
      total: "",
      per_page: 10,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);

    axios.post(endpoints.getAppUser, {}).then((response) => {
      this.setState({
        items: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
     // console.log(response.data);
    });
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;
    const b = this.state.total;
    const dates = new Date();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = months[dates.getMonth()];
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const columns = [
      {
        name: "Name",
        selector: (row) => row.full_name,
        cellExport: (row) => row.full_name,
        sortable: true,
      },
      {
        name: "Mobile Number",
        selector: (row) => row.mobile,
        cellExport: (row) => row.mobile,
        sortable: true,
      },
      {
        name: "Card",
        selector: (row) => row.card_holder_id,
        cellExport: (row) => row.card_holder_id,
        sortable: true,
      },
      {
        name: "Loyalty Points",
        selector: (row) => row.card_holder_point,
        cellExport: (row) => row.card_holder_point,
        sortable: true,
      },
      {
        name: "Card Number",
        selector: (row) => row.card_num,
        cellExport: (row) => row.card_num,
        sortable: true,
      },
    ];

    const onSubmit = async (e) => {
      this.filterfetch(e);
    };
    const bFilter = async () => {
      if (!this.start_date && !this.end_date && !this.card_num) {
        alert("Please Select Any Filter");
        return;
      }
      if (this.start_date && !this.end_date) {
        alert("Please select end date");
        return;
      }
      if (this.end_date && !this.start_date) {
        alert("Please select start date");
        return;
      }
      var card_num = this.card_num;
      var end_date = this.end_date;
      var start_date = this.start_date;

      let a = localStorage.getItem("user");
      let b = JSON.parse(a);
      let user_id = b.id;
      let restro_id = b.restro_id;

      axios
        .post(endpoints.appUserFilter, {
          card_num,
          user_id,
          restro_id,
          start_date,
          end_date,
        })
        .then((response) => {
          this.setState({
            items: response.data.data,

            DataisLoaded: true,
          });
        });
    };
    const onNumChange = (e) => {
      this.card_num = e.target.value;
    };
    const onStartChange = (e) => {
      this.start_date = e.target.value;
    };
    const onEndChange = (e) => {
      this.end_date = e.target.value;
    };

    const data = a;
    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>App Users</h2>
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <label>Start Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Start Date"
                  type="date"
                  name="start_date"
                  place="Start Date"
                  onChange={(e) => onStartChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <label>End Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="End Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  onChange={(e) => onEndChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <div class="form-group">
                  <label for="exampleInputEmail1">Enter Card Number</label>
                  <input
                    type="text"
                    class="form-control"
                    id="exampleInputEmail1"
                    maxLength={5}
                    name="card_num"
                    onChange={(e) => onNumChange(e)}
                    aria-describedby="emailHelp"
                    placeholder="Card Number"
                  />
                  <small id="emailHelp" class="form-text text-muted">
                    Enter last five digit of card number
                  </small>
                </div>
              </div>

              <div className="col-md-3">
                <div className="col col-3">
                  <div className="mt-5 text-center">
                    <Button
                      className="w-50"
                      onClick={() => bFilter()}
                      style={{ color: "white" }}
                      variant="contained"
                      size="medium"
                    >
                      Filter
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Card>
        <div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationPerPage={7}
              paginationRowsPerPageOptions={[7, 14, 21, 28, 35]}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default AppUser;
